var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 1.33301V12.9997C6.00033 13.4417 5.82473 13.8656 5.51217 14.1782C5.19961 14.4907 4.77569 14.6663 4.33366 14.6663C3.89163 14.6663 3.46771 14.4907 3.15515 14.1782C2.84259 13.8656 2.66699 13.4417 2.66699 12.9997V1.33301",
    stroke: "#551EE3",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.33301V12.9997C13.3333 13.4417 13.1577 13.8656 12.8452 14.1782C12.5326 14.4907 12.1087 14.6663 11.6667 14.6663C11.2246 14.6663 10.8007 14.4907 10.4882 14.1782C10.1756 13.8656 10 13.4417 10 12.9997V1.33301",
    stroke: "#551EE3",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.33301H6.66667",
    stroke: "#551EE3",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 1.33301H13.9997",
    stroke: "#551EE3",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00033 10.667H2.66699",
    stroke: "#551EE3",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.667H10",
    stroke: "#551EE3",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabPlaceholder);
export default __webpack_public_path__ + "static/media/LabPlaceholder.536095b76903e6c1065ce113c1bb9948.svg";
export { ForwardRef as ReactComponent };